import { httpsCallable } from 'firebase/functions'
import { functions } from '~/firebase'
import type { IGoogleAutocompleteParams, IInstaQuoteParams, IInstaQuoteSubscriptionCheckParams, IScheduleApi, IVerifyCompanyCustomerParams } from '~/types/estimates/quoteSchedule'

const getGoogleAutocomplete = httpsCallable(functions, 'googlePlacesAutoComplete')
const verifyCompanyCustomer = httpsCallable(functions, 'verifyCompanyCustomer')
const instaQuote = httpsCallable(functions, 'instaQuote')
const instaQuoteSubscriptionCheck = httpsCallable(functions, 'instaQuoteSubscriptionCheck')

export const scheduleApi: IScheduleApi = {
  GOOGLE_AUTOCOMPLETE: async (params: IGoogleAutocompleteParams) => {
    const estimateData = await getGoogleAutocomplete(params)
      .then((result: { data: any }) => {
        // eslint-disable-next-line no-console
        console.log('result.data', result.data)
        return result.data
      })
      .catch((error: any) => {
        // eslint-disable-next-line no-console
        console.log(error)
      })
    return estimateData
  },
  VERIFY_COMPANY_CUSTOMER: async (params: IVerifyCompanyCustomerParams) => {
    const verifyCustomer = await verifyCompanyCustomer(params)
      .then((result: { data: any }) => {
        // eslint-disable-next-line no-console
      // console.log('result2.data', result.data)
        return result.data
      },
      )
      .catch((error: any) => {
        // eslint-disable-next-line no-console
        console.log(error)
      },
      )
    return verifyCustomer
  },
  INSTA_QUOTE: async (params: IInstaQuoteParams) => {
    const schedule = await instaQuote(params)
      .then((result: { data: any }) => {
        // eslint-disable-next-line no-console
        // console.log('instaQuote call params', params);
        // eslint-disable-next-line no-console
        // console.log('instaQuote result.data', result.data)
        return result.data
      },
      )
      .catch((error: any) => {
        // eslint-disable-next-line no-console
        console.log(error)
      },
      )
    return schedule
  },
  INSTA_QUOTE_SUBSCRIPTION_CHECK: async (params: IInstaQuoteSubscriptionCheckParams) => {
    const schedule = await instaQuoteSubscriptionCheck(params)
      .then((result: { data: any }) => {
        // eslint-disable-next-line no-console
        // console.log('instaQuote call params', params);
        // eslint-disable-next-line no-console
        // console.log('instaQuote result.data', result.data)
        return result.data
      },
      )
      .catch((error: any) => {
        // eslint-disable-next-line no-console
        console.log(error)
      },
      )
    return schedule
  },
}
